import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './router';
import Util from '../lib/util';
import axios from 'axios';
import { StartUp } from "@/lib/startup";
Vue.prototype.$axios = axios; // 全局配置注册，使用时是：this.$axios
Vue.use(VueRouter);
// 路由配置
var RouterConfig = {
    // mode: 'history',
    routes: routes
};
export var router = new VueRouter(RouterConfig);
router.beforeEach(function (to, from, next) {
    abp.ui.setBusy();
    Util.title(to.meta.title);
    if (abp.utils.getCookieValue('locking') === '1' && to.name !== 'locking') { // 判断当前是否是锁定状态
        next({
            replace: true,
            name: 'locking'
        });
    }
    else if (abp.utils.getCookieValue('locking') === '0' && to.name === 'locking') {
        next(false);
    }
    else {
        if (!abp.initial) {
            StartUp().then(function () {
                if (!abp.session.userId && to.meta.requiresAuth) { // 判断是否已经登   录且前往的页面不是登录页
                    next({
                        name: 'login',
                        query: { returnUrl: to.path }
                    });
                }
                else if (!!abp.session.userId && to.name === 'login') { // 判断是否已经登录且前往的是登录页
                    Util.title(to.meta.title);
                    next({
                        name: 'home'
                    });
                }
                else {
                    if (!!to.meta.permission) { // 需要判断权限的路由
                        if (abp.auth.hasPermission(to.meta.permission)) {
                            next();
                        }
                        else {
                            next({
                                replace: true,
                                name: 'error-403'
                            });
                        }
                    }
                    else { // 没有配置权限的路由, 直接通过
                        next();
                    }
                }
            });
        }
        else {
            if (!abp.session.userId && to.meta.requiresAuth) { // 判断是否已经登   录且前往的页面不是登录页
                next({
                    name: 'login',
                    query: { returnUrl: to.path }
                });
            }
            else if (!!abp.session.userId && to.name === 'login') { // 判断是否已经登录且前往的是登录页
                Util.title(to.meta.title);
                next({
                    name: 'home'
                });
            }
            else {
                if (!!to.meta.permission) { // 需要判断权限的路由
                    if (abp.auth.hasPermission(to.meta.permission)) {
                        next();
                    }
                    else {
                        next({
                            replace: true,
                            name: 'error-403'
                        });
                    }
                }
                else { // 没有配置权限的路由, 直接通过
                    next();
                }
            }
        }
    }
});
router.afterEach(function (to) {
    abp.ui.clearBusy();
    window.scrollTo(0, 0);
});
